module.exports = "\r\n<ng-container *ngIf=\"datas !== undefined && datas !== null;else emptyHome\">\r\n  <div class=\"card\">\r\n    <div [innerHTML]=\"datas.titre | safeHtml\" class=\"card-header cd34-blue-3\">\r\n      Texte de la page d'accueil\r\n    </div>\r\n    <div [innerHTML]=\"datas.texte | safeHtml\" class=\"card-body\">\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n<ng-template #emptyHome>\r\n  <div [class]=\"homeLoad()\"></div>\r\n</ng-template>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-home-text/app-home-text.component.html
// module id = ./src/app/components/app-home-text/app-home-text.component.html
// module chunks = main